document.querySelectorAll('buy-buttons.buy-buttons--has-dynamic').forEach(function (buyButtons) {
  var initialText = null;
  var unlocked = false;

  // 找一个不会被 product-rerender 整体替换掉的稳定祖先容器来监听；
  // 找不到 product-rerender 就退回监听 document.body，保证任何情况下都不会失效
  var stableAncestor = buyButtons.closest('product-rerender') || document.body;

  // 判断当前 Size 是否已选择：null = Globo UI 还没渲染出来，无法判断
  function isSizeSelected() {
    var valueEl = document.querySelector('.dropdown-button-gsw__value');
    if (!valueEl) return null;

    if (initialText === null) {
      initialText = valueEl.textContent.trim();
      return false;
    }
    return valueEl.textContent.trim() !== initialText;
  }

  // 每次触发都用选择器重新查询当前的按钮元素，不依赖任何缓存的旧节点引用，
  // 这样即使 buy-buttons/按钮节点被整体替换成新节点，也能抓到新的那个
  function syncButtonVisibility() {
    if (unlocked) return;

    var currentWrap = document.querySelector('buy-buttons.buy-buttons--has-dynamic .shopify-payment-button');
    if (!currentWrap) return;

    var selected = isSizeSelected();
    if (selected === null) return;

    if (selected) {
      currentWrap.style.display = '';
      unlocked = true;
      observer.disconnect();
      clearInterval(pollInterval);
    } else {
      currentWrap.style.display = 'none';
    }
  }

  // 轮询：仅用于等待 Globo UI 首次渲染出来并完成首次隐藏，超时（10秒/50次）只停止轮询本身
  var attempts = 0;
  var pollInterval = setInterval(function () {
    attempts++;
    syncButtonVisibility();
    if (unlocked || attempts > 50) {
      clearInterval(pollInterval);
    }
  }, 200);

  // 持续监听稳定祖先容器（product-rerender），不受轮询超时限制，
  // 不管过了多久、重渲染多少次，只要 Size 没选，新节点一出现就立刻重新隐藏
  var observer = new MutationObserver(function () {
    syncButtonVisibility();
  });
  observer.observe(stableAncestor, { childList: true, subtree: true });
});